var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6665 3.66666H5.15666C5.67675 3.66666 5.9368 3.66666 6.14347 3.78063C6.22869 3.82763 6.30589 3.8879 6.37216 3.95918C6.53285 4.13204 6.59592 4.38431 6.72206 4.88888L6.88852 5.55473C6.98117 5.92534 7.0275 6.11065 7.09901 6.2661C7.34723 6.80577 7.84155 7.19173 8.42532 7.30166C8.59348 7.33332 8.78449 7.33332 9.1665 7.33332",
    stroke: "white",
    strokeWidth: 1.83333,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5001 15.5833H6.92176C6.78774 15.5833 6.72074 15.5833 6.66991 15.5777C6.13128 15.5173 5.76231 15.0054 5.87542 14.4754C5.88609 14.4253 5.90729 14.3618 5.94966 14.2347C5.99672 14.0935 6.02024 14.0229 6.04623 13.9607C6.31232 13.323 6.9143 12.8891 7.60337 12.8383C7.67067 12.8333 7.74506 12.8333 7.89385 12.8333H12.8334",
    stroke: "white",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3173 12.8333H10.0598C8.94522 12.8333 8.38792 12.8333 7.95805 12.5809C7.77652 12.4743 7.61469 12.3372 7.47968 12.1756C7.16 11.7931 7.06838 11.2434 6.88515 10.144C6.69949 9.03003 6.60666 8.47303 6.82703 8.06048C6.91903 7.88826 7.04666 7.7376 7.20141 7.61855C7.57212 7.33334 8.13679 7.33334 9.26616 7.33334H15.3669C16.6965 7.33334 17.3612 7.33334 17.6299 7.76809C17.8986 8.20284 17.6013 8.79742 17.0068 9.98654L16.5968 10.8065C16.1038 11.7927 15.8572 12.2857 15.4142 12.5595C14.9711 12.8333 14.4198 12.8333 13.3173 12.8333Z",
    stroke: "white",
    strokeWidth: 1.83333,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5832 19.25C16.0894 19.25 16.4998 18.8396 16.4998 18.3333C16.4998 17.8271 16.0894 17.4167 15.5832 17.4167C15.0769 17.4167 14.6665 17.8271 14.6665 18.3333C14.6665 18.8396 15.0769 19.25 15.5832 19.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25016 19.25C8.75642 19.25 9.16683 18.8396 9.16683 18.3333C9.16683 17.8271 8.75642 17.4167 8.25016 17.4167C7.7439 17.4167 7.3335 17.8271 7.3335 18.3333C7.3335 18.8396 7.7439 19.25 8.25016 19.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.bd8980946fb3770858b2f2f84ffdff4d.svg";
export { ForwardRef as ReactComponent };